import { v4 as uuid } from 'uuid';
import { APITypes } from '../../primary-record-types';

type AnalyticsSession = APITypes.analyticsService.AnalyticsEventSession;

let activeSession: AnalyticsSession | undefined;

/** Mint a new session, replacing any active one. */
export const startSession = (): AnalyticsSession => {
    activeSession = { sessionId: uuid(), startTimestamp: new Date().toISOString() };
    return { ...activeSession };
};

/** The session events currently belong to, or undefined when none is open. */
export const getActiveSession = (): AnalyticsSession | undefined => activeSession && { ...activeSession };

/** End the active session and return it stamped with its end time, or undefined if none was active. */
export const stopSession = (): AnalyticsSession | undefined => {
    if (!activeSession) return undefined;

    const endedSession = { ...activeSession, endTimestamp: new Date().toISOString() };
    activeSession = undefined;
    return endedSession;
};
